import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { IconContext } from 'react-icons/lib';
import useMutationQueueProcessor from 'hooks/useMutationQueueProcessor';
import BottomNav from './BottomNav';
import Header from './Header';

const Navigation = ({ children }: { children: ReactNode }) => {
  // Processes the mutation queue to execute offline mutations when online
  useMutationQueueProcessor();

  return (
    <IconContext.Provider value={{ style: { verticalAlign: 'middle' } }}>
      <Header />
      <Box
        id="bodyContent"
        sx={(theme) => ({
          touchAction: 'pan-x pan-y',
          marginTop: theme.spacing(8),
          [theme.breakpoints.down('md')]: { marginTop: 0 },
        })}
      >
        {children}
      </Box>
      <BottomNav />
    </IconContext.Provider>
  );
};

export default Navigation;
